var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrder = function SvgOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.636,
    d: "M18.709 11.459V6.234c0-1.54 0-2.31-.3-2.898a2.75 2.75 0 0 0-1.202-1.202c-.588-.3-1.358-.3-2.898-.3H8.442c-1.54 0-2.31 0-2.898.3a2.75 2.75 0 0 0-1.202 1.202c-.3.588-.3 1.358-.3 2.898v9.533c0 1.54 0 2.31.3 2.899a2.75 2.75 0 0 0 1.202 1.202c.588.3 1.358.3 2.898.3h2.933m1.834-10.084h-5.5m1.833 3.667H7.709m7.333-7.334H7.709m5.958 11 1.833 1.834 4.125-4.125"
  })));
};
export default SvgOrder;